var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartWarningLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0001 56.1196C45.0883 56.1196 56.509 44.6989 56.509 30.6107C56.509 16.5225 45.0883 5.10181 31.0001 5.10181C16.9119 5.10181 5.49121 16.5225 5.49121 30.6107C5.49121 44.6989 16.9119 56.1196 31.0001 56.1196Z",
    stroke: "#E95832",
    strokeWidth: 5.10178,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40.8141V30.6106",
    stroke: "#E95832",
    strokeWidth: 5.10178,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 20.4072H31.0255",
    stroke: "#E95832",
    strokeWidth: 5.10178,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartWarningLogo);
export default __webpack_public_path__ + "static/media/cartWarningLogo.88d6c12250b0b901bcf2c65229dba298.svg";
export { ForwardRef as ReactComponent };